enum ReviewsSorterType {
	DATE_DESC = 'DATE_DESC',
	RATING_ASC = 'RATING_ASC',
	RATING_DESC = 'RATING_DESC',
}

export default ReviewsSorterType;